import "./blog.js";
import Splide from "./lib/splide.min.js";
import { forEach } from "./utils.js";

document.addEventListener("DOMContentLoaded", () => {
	document.querySelector(".mobileMenuOverlay").addEventListener("click", function (e) {
		e.preventDefault();
		document.querySelector(".menu-icon__cheeckbox").checked = false;
	});

	let latest_slider = document.getElementById("latest_slider");

	if (latest_slider) {
		let options = {
			type: "loop",
			perPage: 1,
			arrows: false,
			pagination: false,
			autoplay: true,
			interval: 3000,
		};
		let splide = new Splide(latest_slider, options);
		splide.mount();
	}

	let dropdowns = document.querySelectorAll(".menu-item-has-children > a");
	forEach(dropdowns, (item) => {
		item.addEventListener("click", (e) => {
			e.preventDefault();
			item.parentElement.classList.toggle("openMenuDropdown");
		});
	});
});
